module.exports = __webpack_public_path__ + "media/images/countrysquared/ro-214a968e87931ba65a7972800ba73b54.svg";